import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import EmailIcon from '@material-ui/icons/Email';
import ChatIcon from '@material-ui/icons/Chat';
import CardBox from '../kea/CardBox';
import IntlMessages from '../../util/IntlMessages';
import './support-row.scss';

export default function SupportRow() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <CardBox styleName="support-row__card">
          <Typography className="support-row__title">
            <IntlMessages id="support.help.email.title" />
          </Typography>
          <Typography className="support-row__subtitle">
            <IntlMessages id="support.help.email.subtitle1" />
          </Typography>
          <Typography className="support-row__subtitle">
            <IntlMessages id="support.help.email.subtitle2" />
          </Typography>
          <Link href="mailto:support@kealabs.com" className="support-row__link">
            <EmailIcon className="support-row__icon" />
            support@kealabs.com
          </Link>
        </CardBox>
      </Grid>
      <Grid item xs={12} sm={6}>
        <CardBox styleName="support-row__card">
          <Typography className="support-row__title">
            <IntlMessages id="support.help.chat.title" />
          </Typography>
          <Typography className="support-row__subtitle">
            <IntlMessages id="support.help.chat.subtitle1" />
          </Typography>
          <Typography className="support-row__subtitle">
            <IntlMessages id="support.help.chat.subtitle2" />
          </Typography>
          <Link target="_blank" href="https://kealabs.com" className="support-row__link">
            <ChatIcon className="support-row__icon" />
            kealabs.com
          </Link>
        </CardBox>
      </Grid>
    </Grid>
  );
}
